import component from './affiliates.component';

const module = angular.module('affiliates', [])
	.component('affiliates', component)
	.name;

export default module;



// WEBPACK FOOTER //
// ./app/components/affiliates/affiliates.js